(function () {
  function initStory(root) {
    root.classList.add('is-enhanced');

    var beatObserver = null;
    var ctaObserver = null;

    if ('IntersectionObserver' in window) {
      beatObserver = observeBeats(root);
      ctaObserver = observeStickyCta(root);
    }

    window.addEventListener('pagehide', function () {
      if (beatObserver) {
        beatObserver.disconnect();
      }
      if (ctaObserver) {
        ctaObserver.disconnect();
      }
    }, { once: true });
  }

  function observeBeats(root) {
    var beats = Array.prototype.slice.call(root.querySelectorAll('[data-story-beat]'));

    if (!beats.length) {
      return null;
    }

    var observer = new IntersectionObserver(function (entries) {
      var activeEntry = entries
        .filter(function (entry) {
          return entry.isIntersecting;
        })
        .sort(function (a, b) {
          return b.intersectionRatio - a.intersectionRatio;
        })[0];

      if (!activeEntry) {
        return;
      }

      beats.forEach(function (beat) {
        beat.classList.toggle('is-active', beat === activeEntry.target);
      });
    }, {
      root: null,
      rootMargin: '-30% 0px -35% 0px',
      threshold: [0.1, 0.25, 0.5, 0.75]
    });

    beats.forEach(function (beat) {
      observer.observe(beat);
    });

    return observer;
  }

  function observeStickyCta(root) {
    var stickyCta = root.querySelector('[data-story-sticky-cta]');
    var hero = root.querySelector('.acustom-story__hero');

    if (!stickyCta || !hero) {
      return null;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, {
      root: null,
      threshold: 0
    });

    observer.observe(hero);
    return observer;
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-acustom-story]')).forEach(initStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
